/** Unique keys for DTOs from "saas" module */
export enum SaasDtoKeysEnum {
  /** FRM instance own filters */
  FRM_INSTANCE_FILTERS_DTO = 'saas/frm-instance-filters.dto',
  /** FRM instance find many API query parameters */
  FRM_INSTANCE_FIND_MANY_QUERY_DTO = 'saas/frm-instance-find-many-query.dto',
  /** FRM instance find one API query parameters */
  FRM_INSTANCE_FIND_ONE_QUERY_DTO = 'saas/frm-instance-find-one-query.dto',
  /** FRM instance response body */
  FRM_INSTANCE_FIND_DTO = 'saas/frm-instance-find.dto',
  /** FRM instance create and update APIs request body */
  FRM_INSTANCE_FORM_DTO = 'saas/frm-instance-form.dto',
  /** FRM instance find many API response body */
  FRM_INSTANCE_PAGE_DTO = 'saas/frm-instance-page.dto',
  /** FRM instance partial update API request body */
  FRM_INSTANCE_PARTIAL_FORM_DTO = 'saas/frm-instance-partial-form.dto',
  /** FRM instance selection settings */
  FRM_INSTANCE_SELECT_DTO = 'saas/frm-instance-select.dto',
  /** FRM instance sorting settings */
  FRM_INSTANCE_SORT_DTO = 'saas/frm-instance-sort.dto',
  /** Profile available tenants response body */
  AVAILABLE_TENANTS_DTO = 'saas/available-tenants.dto',
  /** "BRS" module settings common request and response body */
  BRS_SETTINGS_DTO = 'saas/brs-settings.dto',
  /** Common tenant settings common request and response body */
  COMMON_SETTINGS_DTO = 'saas/common-settings.dto',
  /** Project tenant settings common request and response body */
  PROJECT_SETTINGS_DTO = 'saas/project-settings.dto',
  /** Event calendar settings common request and response body */
  EVENT_CALENDAR_SETTINGS_DTO = 'saas/event-calendar-settings.dto',
  /** Global settings APIs response body */
  GLOBAL_SETTINGS_FIND_DTO = 'saas/global-settings-find.dto',
  /** Global settings edit API request body */
  GLOBAL_SETTINGS_FORM_DTO = 'saas/global-settings-form.dto',
  /** Dates of prohibition of editing of facts (documents) according to methods of accounting */
  PLAN_FACT_SETTINGS_FACT_RESTRICT_DATES_DTO = 'saas/plan-fact-settings-fact-restrict-dates.dto',
  /** "Plan/Fact" module settings read and save APIs common request body */
  PLAN_FACT_SETTINGS_DTO = 'saas/plan-fact-settings.dto',
  /** Tenant API's response body */
  TENANT_FIND_DTO = 'saas/tenant-find.dto',
  /** Tenant list API's response body */
  TENANT_PAGE_FIND_DTO = 'saas/tenant-page-find.dto',
  /** Tenant updating data transferable object request body */
  TENANT_FORM_DTO = 'saas/tenant-form.dto',
  /** Aggregated tenant subdomains */
  TENANT_SUBDOMAINS_DTO = 'saas/tenant-subdomains.dto',
  /** Taken subdomain response body */
  TAKEN_SUBDOMAIN_DTO = 'saas/taken-subdomain.dto',
  /** Rate plan find many API query parameters */
  RATE_PLAN_FIND_MANY_QUERY_DTO = 'saas/rate-plan-find-many-query.dto',
  /** Rate plan find one API query parameters */
  RATE_PLAN_FIND_ONE_QUERY_DTO = 'saas/rate-plan-find-one-query.dto',
  /** Rate plan API's response body */
  RATE_PLAN_FIND_DTO = 'saas/rate-plan-find.dto',
  /** Rate plan history page pagination response body */
  RATE_PLAN_HISTORY_PAGE_DTO = 'saas/rate-plan-history-page.dto',
  /** Rate plan history pagination response body */
  RATE_PLAN_HISTORY_FIND_DTO = 'saas/rate-plan-history-find.dto',
  /** Rate plan create/update form API request body */
  RATE_PLAN_FORM_DTO = 'saas/rate-plan-form.dto',
  /** Rate plan find many API response body */
  RATE_PLAN_PAGE_DTO = 'saas/rate-plan-page.dto',
  /** Rate plan partial update API request body */
  RATE_PLAN_PARTIAL_FORM_DTO = 'saas/rate-plan-partial-form.dto',
  /** Rate plan selection settings */
  RATE_PLAN_SELECT_DTO = 'saas/rate-plan-select.dto',
  /** Rate plan sort settings */
  RATE_PLAN_SORT_DTO = 'saas/rate-plan-sort.dto',
  /** Simple tenant creation request body */
  TENANT_SIMPLE_FORM_DTO = 'saas/tenant-simple-form.dto',
  /** Simple external tenant request body */
  TENANT_EXTERNAL_SIMPLE_FORM_DTO = 'saas/tenant-external-simple-form.dto',
  /** Tenant statistics API's response body */
  TENANT_STATISTICS_FIND_DTO = 'saas/tenant-statistics-find.dto',
  /** Tenant statistics metric API's response body */
  TENANT_STATISTICS_METRIC_FIND_DTO = 'saas/tenant-statistics-metric-find.dto',
  /** Tenant with enabled and disabled modules */
  TENANT_MODULES_FIND_DTO = 'saas/tenant-modules-find.dto',
  /** Slice of tenant history (JSON "page") - response body */
  TENANT_HISTORY_PAGE_DTO = 'saas/tenant-history-page.dto',
  /** Tenant history entry - response body */
  TENANT_HISTORY_FIND_DTO = 'saas/tenant-history-find.dto',
  /** Tenant creation data transferable object */
  TENANT_CREATE_FORM_DTO = 'saas/tenant-create-form.dto',
  /** Tenant search form with pagination support */
  TENANT_QUERY_DTO = 'saas/tenant-query.dto',
  /** Available tenant subdomains API response body */
  TENANT_AVAILABLE_SUBDOMAINS_DTO = 'saas/tenant-available-subdomains.dto',
  /** Tenant create/update request body */
  TENANT_PERSONAL_FORM_DTO = 'saas/tenant-personal-form.dto',
  /** Tenant update request body - extended version for admin tenant */
  TENANT_ADMIN_FORM_DTO = 'saas/tenant-admin-form.dto',
  /** Tenant analytics base item */
  TENANT_ANALYTICS_ITEM_BASE_DTO = 'saas/tenant-analytics-item-base.dto',
  /** Tenant analytics objects creation details item */
  TENANT_ANALYTICS_OBJECT_DETAILS_ITEM_DTO = 'saas/tenant-analytics-object-details-item.dto',
  /** Tenant analytics API query parameters */
  TENANT_ANALYTICS_QUERY_DTO = 'saas/tenant-analytics-query.dto',
  /** Tenant analytics section row response body */
  TENANT_ANALYTICS_SECTION_DTO = 'saas/tenant-analytics-section.dto',
  /** Tenant analytics tab row response body */
  TENANT_ANALYTICS_TAB_DTO = 'saas/tenant-analytics-tab.dto',
  /** Tenant statistics request params */
  TENANT_STATISTICS_QUERY_DTO = 'saas/tenant-statistics-query.dto',
  /** Personal account transaction APIs response body */
  PERSONAL_ACCOUNT_TRANSACTION_FIND_DTO = 'saas/personal-account-transaction-find.dto',
  /** Slice of personal account transactions */
  PERSONAL_ACCOUNT_TRANSACTION_PAGE_DTO = 'saas/personal-account-transaction-page.dto',
  /** Disable debit welcome request params */
  DISABLE_DEBIT_WELCOME_QUERY_DTO = 'saas/disable-debit-welcome-query.dto',
  /** Subdomain per type response body */
  SUBDOMAIN_PER_TYPE_DTO = 'saas/subdomain-per-type.dto',
  /** Reserved subdomain response body */
  RESERVED_SUBDOMAIN_FIND_DTO = 'saas/reserved-subdomain-find.dto',
  /** Reserved subdomain save API request body */
  RESERVED_SUBDOMAIN_FORM_DTO = 'saas/reserved-subdomain-form.dto',
  /** Reserved subdomain single APIs URL parameters */
  RESERVED_SUBDOMAIN_PARAMS_DTO = 'saas/reserved-subdomain-params.dto',
}
